import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import './App.css';
import Home from './pages/Home';
import Club from './pages/Club';
import Equipo from './pages/Equipo';
import Campeonatos from './pages/Campeonatos';
import Calendario from './pages/Calendario';
import Noticias from './pages/Noticias';
import Deportes from './pages/Deportes';
import Tienda from './pages/Tienda';
import Socios from './pages/Socios';
import NoticiaDetalle from './pages/NoticiaDetalle';
import Galeria from './pages/Galeria'; // ✅ NUEVO
import JugadorDelPartido from './pages/JugadorDelPartido'; // 👈 IMPORTAR
import DiaDelPadre from "./pages/diadelpadre"; // Asegurate que el nombre y ruta coinciden
import Acreditaciones from './pages/Acreditaciones';
import Backoffice from "./pages/Backoffice";


function App() {
  return (
    <Router>
      <Header />
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/club" element={<Club />} />
        <Route path="/equipo" element={<Equipo />} />
        <Route path="/campeonatos" element={<Campeonatos />} />
        <Route path="/calendario" element={<Calendario />} />
        <Route path="/noticias" element={<Noticias />} />
        <Route path="/noticias/:id" element={<NoticiaDetalle />} />
        <Route path="/deportes" element={<Deportes />} />
        <Route path="/tienda" element={<Tienda />} />
        <Route path="/galeria" element={<Galeria />} /> {/* ✅ NUEVA RUTA */}
        <Route path="/socios" element={<Socios />} />
        <Route path="/jugador-del-partido" element={<JugadorDelPartido />} />
<Route path="/diadelpadre" element={<DiaDelPadre />} />
<Route path="/acreditaciones" element={<Acreditaciones />} />
<Route path="/backoffice" element={<Backoffice />} />

      </Routes>

      <Footer />
    </Router>
  );
}

export default App;
